export enum LogLevel
{
    Trace = "Trace",
    Verbose = "Verbose",
    Debug = "Debug",
    Info = "Info",
    Success = "Success",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    Fatal = "Fatal"
}